module.exports = __webpack_public_path__ + "static/media/youtube.a04938a0.png";